import SqlIcon from "./SqlIcon";
import ExcelIcon from "./ExcelIcon";
import PythonIcon from "./PythonIcon";
import TableauIcon from "./TableauIcon";
import MSPowerBIIcon from "./MSPowerBIIcon";

import GSIcon from "../assets/GSIcon.svg";
import BigQuesry from "../assets/google-bigquery.svg";

export const dataAnalyticsBootcampLogos = [
  { icon: ExcelIcon },
  { icon: TableauIcon },
  { icon: SqlIcon },
  { icon: MSPowerBIIcon },
];

export const dataScienceBootcampLogos = [
  { icon: GSIcon, type: "image" },
  { icon: SqlIcon },
  { icon: PythonIcon },
  { icon: BigQuesry, type: "image" },
];

export const hearFromOurStudents = [
  {
    name: "Theresa Abuo",
    occupation: "Data Analyst & Agric Extension Agent",
    thumbNail:
      "https://storage.googleapis.com/resagratia-webapp/misc/bootcamp_page/DATA%20BOOTCAMP%20EXPERIENCE%20-%20Theresa%20Abuo%20Placeholder%20Image.jpg",
    video: `https://storage.googleapis.com/resagratia-webapp/misc/bootcamp_page/Data%20Bootcamp%20Experience%20-%20Theresa%20Abuo.mp4`,
  },
  {
    name: "Dami Alabi",
    occupation: "Marine Biologist",
    thumbNail:
      "https://storage.googleapis.com/resagratia-webapp/misc/bootcamp_page/DATA%20BOOTCAMP%20EXPERIENCE%20-%20Dami%20Alabi%20Placeholder%20Image.jpg",
    video: `https://storage.googleapis.com/resagratia-webapp/misc/bootcamp_page/DATA%20BOOTCAMP%20EXPERIENCE%20-%20Dami%20Alabi.mp4`,
  },
  {
    name: "Onyinyechi Eze",
    occupation: "Engineer / Data Analyst",
    thumbNail:
      "https://storage.googleapis.com/resagratia-webapp/misc/bootcamp_page/DATA%20BOOTCAMP%20EXPERIENCE%20-%20Onyinyechi%20Eze%20Placeholder%20Image.jpg",
    video: `https://storage.googleapis.com/resagratia-webapp/misc/bootcamp_page/Data%20Bootcamp%20Experience%20-%20Onyinyechi%20Eze.mp4`,
  },
  {
    name: "Chinaza MaryTheresa",
    occupation: "Pharmacist",
    thumbNail:
      "https://storage.googleapis.com/resagratia-webapp/misc/bootcamp_page/DATA%20BOOTCAMP%20EXPERIENCE%20-%20Chinaza%20MT%20Placeholder%20Image.jpg",
    video: `https://storage.googleapis.com/resagratia-webapp/misc/bootcamp_page/Data%20Bootcamp%20Experience%20-%20Chinaza%20MT.mp4`,
  },
  {
    name: "Timilehin Oriola",
    occupation: "Data Analyst and Mathematician",
    thumbNail:
      "https://storage.googleapis.com/resagratia-webapp/misc/bootcamp_page/grad_oriola_timilehin.jpeg",
    video: `https://storage.googleapis.com/resagratia-webapp/bootcamp_video_reviews/data_bootcamp_experience_oriola_timilehin.mp4`,
  },
  {
    name: "Omowunmi Olabanji",
    occupation: "Optometrist",
    thumbNail:
      "https://storage.googleapis.com/resagratia-webapp/misc/bootcamp_page/grad_omowunmi_olabanji.jpg",
    video: `https://storage.googleapis.com/resagratia-webapp/bootcamp_video_reviews/data_bootcamp_experience_omowunmi.mp4`,
  },
  {
    name: "Chinonso Steve",
    occupation: "Web Developer and Analyst",
    thumbNail:
      "https://storage.googleapis.com/resagratia-webapp/misc/bootcamp_page/grad_chinonso_steve.jpg",
    video: `https://storage.googleapis.com/resagratia-webapp/bootcamp_video_reviews/data_bootcamp_experience_steve_04_2023.mp4`,
  },
  {
    name: "Gbemisola Odedina",
    occupation: "Logistics Analyst",
    thumbNail:
      "https://storage.googleapis.com/resagratia-webapp/misc/bootcamp_page/grad_gbemisola_odedina.jpeg",
    video: `https://storage.googleapis.com/resagratia-webapp/bootcamp_video_reviews/data_bootcamp_experience_fisayo_and_gbemisola.mp4`,
  },
  {
    name: "Dolapo Hammed",
    occupation: "HR Analyst",
    thumbNail:
      "https://storage.googleapis.com/resagratia-webapp/misc/bootcamp_page/graduate_dolapo_hammed.jpeg",
    video: `https://storage.googleapis.com/resagratia-webapp/bootcamp_video_reviews/data_bootcamp_experience_dolapo_04_2023.mp4`,
  },
];

export const dataAnalyticsOffers = [
  "4 months online with real-world exercises and practical projects",
  "Instructor-led training + self-paced components",
  "Access to daily, curated data-related jobs",
  "Saturday mentorship sessions with industry practitioners",
  "Study in groups, build portfolio projects with job preparation support",
  "Internship Opportunities",
  "Learn Excel, Tableau, SQL, and Power BI",
];

export const dataScienceOffers = [
  "4 months online with real-world, practical programming exercises",
  "Instructor-led training + self-paced components",
  "Access to daily, curated data-related jobs",
  "Saturday mentorship sessions with industry Data Scientists",
  "Study in groups, build portfolio projects with job preparation support",
  "Internship Opportunities",
  "Learn Google Sheets, SQL, Google BigQuery, and Python",
];

export const introToDataAnalytics = [
  "5 weeks online",
  "Instructor-led + self-paced learning",
  "Practical problem-solving exercises",
  "Weekly mentor sessions with industry practitioners",
];

export const dataAnalyticsRoadmap = {
  courseName: "Data Analytics Bootcamp",
  additionalNote: "",
  desc: "Data analytics is a broader term that encompasses various techniques and processes used to gather and store data, transform, analyse, visualize data, and predict outcomes. Data analytics often involves not only analyzing historical data but also predicting future trends and outcomes. This bootcamp is perfect for those looking to start a career in data analysis, data science, and data engineering - including applying the skills to your current role at work.",
  courseOutline: [
    {
      courseName: "Introduction to Excel",
      duration: "week 1 - 2",
      img: "https://storage.googleapis.com/resagratia-webapp/course_resources_general/logos/excel_new_logo_large.png",
      desc: "",
    },
    {
      courseName: "Business Analytics with Excel",
      duration: "week 3 - 4",

      img: "https://storage.googleapis.com/resagratia-webapp/course_resources_general/logos/excel_new_logo_large.png",
      desc: "",
    },
    {
      courseName: "Power BI Fundamentals",
      duration: "week 5 - 6",
      img: "https://storage.googleapis.com/resagratia-webapp/course_resources_general/logos/power_bi_logo_new.png",
      desc: "",
    },
    {
      courseName: "Tableau Fundamentals",
      duration: "week 7 - 8",
      img: "https://storage.googleapis.com/resagratia-webapp/course_resources_general/logos/tableau_logo.png",
      desc: "",
    },
    {
      courseName: "Data Analysis with SQL",
      duration: "week 9 - 10",
      img: "https://storage.googleapis.com/resagratia-webapp/course_resources_general/logos/Postgresql_elephant.svg.png",
      desc: "",
    },
    {
      courseName: "GDP Analysis - Tableau / Power BI",
      duration: "week 11 - 12",
      img: "https://storage.googleapis.com/resagratia-webapp/course_resources_general/logos/power_bi_logo_new.png",
      desc: "",
    },
    {
      courseName: "-- Break (Capstone Projects & AI Use Cases) --",
      duration: "week 13 - 14",
      img: "https://storage.googleapis.com/resagratia-webapp/course_resources_general/logos/power_bi_logo_new.png",
      desc: "",
    },
    {
      courseName: "Data Science with SQL",
      duration: "week 15 - 16",
      img: "https://storage.googleapis.com/resagratia-webapp/course_resources_general/logos/power_bi_logo_new.png",
      desc: "",
    },
    {
      courseName: "Data Science with SQL",
      duration: "week 17 - 18",
      img: "https://storage.googleapis.com/resagratia-webapp/course_resources_general/logos/power_bi_logo_new.png",
      desc: "",
    },
    {
      courseName: "Introduction to Python",
      duration: "week 19 - 20",
      img: "https://storage.googleapis.com/resagratia-webapp/course_resources_general/logos/power_bi_logo_new.png",
      desc: "",
    },
    {
      courseName: "Data Science with Python",
      duration: "week 21 - 22",
      img: "https://storage.googleapis.com/resagratia-webapp/course_resources_general/logos/power_bi_logo_new.png",
      desc: "",
    },
    {
      courseName: "Machine Learning Case Study Projects",
      duration: "week 23 - 24",
      img: "https://storage.googleapis.com/resagratia-webapp/course_resources_general/logos/power_bi_logo_new.png",
      desc: "",
    },
    {
      courseName: "Graduation",
      duration: "week 25",
      img: "https://storage.googleapis.com/resagratia-webapp/course_resources_general/logos/power_bi_logo_new.png",
      desc: "",
    },
  ],
};

export const dataFoundationRoadmap = {
  courseName: "Data Foundations",
  additionalNote: "",
  desc: `In today’s digital age, data drives decisions across every industry. Our Data Foundations program equips you with in-demand skills to thrive in this evolving landscape. Through a structured curriculum, you’ll explore the fundamentals of data, why it matters, how it shapes global systems, and the tools to turn raw information into actionable insights.
Master platforms like Excel, Google Sheets, and Power BI to analyze business data with confidence, and position yourself for success in a job market where digital skills are growing 2.5x faster than non-digital roles.`,
  courseOutline: [
    {
      courseName: "Introduction to Statistical Data Analysis",
      duration: "Course 1",
      img: "https://storage.googleapis.com/resagratia-webapp/course_resources_general/logos/excel_new_logo_large.png",
      desc: "",
    },
    {
      courseName:
        "Analytics and Data Visualization - Heatmaps in Excel",
      duration: "Course 2",

      img: "https://storage.googleapis.com/resagratia-webapp/course_resources_general/logos/excel_new_logo_large.png",
      desc: "",
    },
    {
      courseName: "Expenses Management in Power BI",
      duration: "Course 3",
      img: "https://storage.googleapis.com/resagratia-webapp/course_resources_general/logos/power_bi_logo_new.png",
      desc: "",
    },
    {
      courseName: "Graduation",
      duration: "Final",
      img: "https://storage.googleapis.com/resagratia-webapp/course_resources_general/logos/tableau_logo.png",
      desc: "",
    },
  ],
};

export const dataScienceRoadmap = {
  courseName: "Data Science Bootcamp",
  additionalNote:
    "Certificates are good but skills are better. As a fresh Data Scientist after graduating, we guide you to set up and use Git and GitHub effectively for your data portfolio of works in weeks 13 - 14. Learning is a life-long sport and we support you to apply your skills to additional real-world challenges including working with platforms like Kaggle.",
  desc: "Data Science is an interdisciplinary field that combines statistics, maths, programming, and domain expertise to extract meaningful insights from data. Our Data Science Bootcamp goes beyond traditional data analysis, delving into machine learning, predictive modeling, and AI. Perfect for aspiring data scientists, this intensive program equips participants with the tools and knowledge to solve complex problems and drive innovation.",
  courseOutline: [
    {
      courseName: "Google Sheets Essentials",
      duration: "week 1 - 2",
      img: "https://storage.googleapis.com/resagratia-webapp/misc/sheets.svg",
      desc: "We begin with a deep understanding of Spreadsheets for analytics. Google Sheets is a versatile, online-based tool for data management, analysis, collaboration, and data visualization. Students will understand how to clean data, write custom functions, import HTML, manipulate text, use pivot tables and visualize data, collaborate with others, and learn to use the BigQuery data connector.",
    },
    {
      courseName: "Data Analysis with SQL",
      duration: "week 3 - 4",
      img: "https://storage.googleapis.com/resagratia-webapp/course_resources_general/logos/Postgresql_elephant.svg.png",
      desc: "Get hands-on with SQL right from your browser in our captivating course, where we explore the Game of Thrones dataset using a storytelling approach. From understanding relational databases and data modeling to mastering SQL building blocks, JOINs, UNIONs, and subqueries, we guide you through practical exercises every step of the way.",
    },
    {
      courseName: "SQL for Data Science",
      duration: "week 5 - 6",
      img: "https://storage.googleapis.com/resagratia-webapp/course_resources_general/logos/Postgresql_elephant.svg.png",
      desc: "We continue with SQL by covering more advanced concepts on the use of CTEs for data engineering pipelines, subqueries and window functions to solve practical, real-world challenges. This course focuses on problem-solving scenarios involving advanced JOINs, arrays, table creation and views, and indexing using PostgreSQL and Google BigQuery.",
    },
    {
      courseName: "Python Fundamentals",
      duration: "week 7 - 8",
      img: "https://storage.googleapis.com/resagratia-webapp/misc/python-logo-notext.svg",
      desc: "Embark on an enriching journey into the world of programming with our Python Fundamentals. Python is easy to write and understand; it stands as the tool of choice for data science. Perfect for beginners, our fundamentals course covers concepts on numbers and operators, manipulating data types, loops, lists, dictionaries, and writing your own custom functions to solve practical problems.",
    },
    {
      courseName: "Data Science with Python",
      duration: "week 9 - 10",
      img: "https://storage.googleapis.com/resagratia-webapp/misc/python-logo-notext.svg",
      desc: "This is where it gets more exciting and in-depth with the use of Python for data science. Building on the fundamentals, we cover data manipulation in Pandas, NumPy, data visualization with Matplotlib, Folium and Seaborn libraries, statistical exploratory data analysis, dimensionality reduction and machine learning (supervised + unsupervised) while applying these concepts to real world use cases.",
    },
    {
      courseName: "Case Study Projects",
      duration: "week 11 - 12",
      img: "https://storage.googleapis.com/resagratia-webapp/course_resources_general/logos/data_science_week11-14.png",
      desc: "Work on structured and unstructured data to perform exploratory data analyses to extract useful features for your machine learning projects. The projects are very hands-on and students will build predictive models that solve peculiar industry challenges. Our students are not alone; our vetted, expert mentors provide continuous support and offer domain expertise to ensure project completion.",
    },
  ],
};

export const introDataAnalyticsRoadmap = {
  courseName: "Introduction To Data Analytics",
  additionalNote:
    "Certificates are good but skills are better. As a fresh Data Scientist after graduating, we guide you to set up and use Git and GitHub effectively for your data portfolio of works in weeks 13 - 14. Learning is a life-long sport and we support you to apply your skills to additional real-world challenges including working with platforms like Kaggle.",
  desc: "Data Science is an interdisciplinary field that combines statistics, maths, programming, and domain expertise to extract meaningful insights from data. Our Data Science Bootcamp goes beyond traditional data analysis, delving into machine learning, predictive modeling, and AI. Perfect for aspiring data scientists, this intensive program equips participants with the tools and knowledge to solve complex problems and drive innovation.",
  courseOutline: [
    {
      courseName: "Microsoft Excel Essentials",
      duration: "week 1 - 2",
      img: "https://storage.googleapis.com/resagratia-webapp/course_resources_general/logos/excel_new_logo_large.png",
      desc: "We begin with a deep understanding of Spreadsheets for analytics. Google Sheets is a versatile, online-based tool for data management, analysis, collaboration, and data visualization. Students will understand how to clean data, write custom functions, import HTML, manipulate text, use pivot tables and visualize data, collaborate with others, and learn to use the BigQuery data connector.",
    },
    {
      courseName: "Advanced Excel",
      duration: "week 3 - 4",
      img: "https://storage.googleapis.com/resagratia-webapp/course_resources_general/logos/excel_new_logo_large.png",
      desc: "Get hands-on with SQL right from your browser in our captivating course, where we explore the Game of Thrones dataset using a storytelling approach. From understanding relational databases and data modeling to mastering SQL building blocks, JOINs, UNIONs, and subqueries, we guide you through practical exercises every step of the way.",
    },
    {
      courseName: "Case Study Projects",
      duration: "week 5",
      img: "https://storage.googleapis.com/resagratia-webapp/course_resources_general/logos/data_science_week11-14.png",
      desc: "Work on structured and unstructured data to perform exploratory data analyses to extract useful features for your machine learning projects. The projects are very hands-on and students will build predictive models that solve peculiar industry challenges. Our students are not alone; our vetted, expert mentors provide continuous support and offer domain expertise to ensure project completion.",
    },
  ],
};

export const jobHuntInstructions = [
  "Highlight your bootcamp accomplishments",
  "Build meaningful relationships with potential employers",
  "Create a website or platform showcasing your diverse skillset",
  "participate in hackathons, and contribute to open-source projects.",
  "Be persistent, patient, and learn from every interaction.",
];

export const stats = [
  { name: "Students and professionals", num: "2017+" },
  { name: "Countries represented", num: "37" },
  { name: "Types of professionals", num: "30+" },
];

export const FAQs = [
  {
    id: 1,
    question: "What is the mode of learning?",
    answer: [
      "Our Data Bootcamps are online and delivered in a mixed format involving self-paced learning on Resagratia and live, online tutoring every Saturday, 6 PM - 8 PM. Students are also supported on Discord by our teaching assistants to answer pressing questions. Students are actively engaged to maintain high retention until completion.",
    ],
  },
  {
    id: 2,
    question: "Are the sessions recorded?",
    answer: [
      "Yes, the Saturday mentor sessions are recorded for viewing later. The recordings are shared one or two days after the live tutoring sessions.",
    ],
  },
  {
    id: 3,
    question: "Do you have discounts?",
    answer: [
      "Yes, discounts are available starting from 5% off, up to 30% off. The discount codes are generally available on the banner and are issued at random points in time. For special promotions, discount codes are shared via email.",
      "You can also take advantage of our convenient payment plan option at the point of payment for the bootcamp.",
    ],
  },
  {
    id: 4,
    question:
      "Is this for beginners and people with non-science backgrounds?",
    answer: [
      "Data Analytics and Data Science skills are for people from any educational or professional background without any discrimination. Our Data Bootcamps are very beginner friendly and the concepts are explained in bite-sized chunks by expert instructors with deep passion for teaching.",
      "Data literacy is for everyone and the world will be littered with citizen analysts in the future of work. Data Analytics and Data Science skills will be used by anyone from any industry to solve domain-specific problems.",
    ],
  },
  {
    id: 5,
    question: "Will I earn a certificate after the Data Bootcamp?",
    answer: [
      "Yes, once you meet all the requirements to earn our coveted Bootcamp Completion certificate. The certificate is hosted online and can be added to your LinkedIn profile to increase awareness of your new skills.",
    ],
  },
  {
    id: 6,
    question: "How many hours per week will I need to dedicate?",
    answer: [
      "The self-paced component requires at least 3 hours per week to complete learning objectives, quizzes and assessments. We encourage additional 1-2 hours per week to complete further reading and practical exercises.",
      "The live tutoring sessions require 1 hour 30 minutes every Saturday.",
    ],
  },
  {
    id: 7,
    question: "Are there physical classes?",
    answer: [
      "No, none for the Data Bootcamps, however, we run corporate tailored data analytics and data science trainings upon request.",
      "Please email servus@resagratia.com for more information.",
    ],
  },
  {
    id: 8,
    question:
      "What opportunities are there after graduating from this Data Bootcamp?",
    answer: [
      "Firstly, we offer limited internships to the best graduates from our Data Analytics Bootcamp.",
      "Secondly, based on your capabilities, your industry, and the skills you’ve gained during the Data Bootcamp, there are many job roles that you can look forward to including:",
    ],
    list: [
      "Data Analyst",
      "Business Intelligence Analyst / Product Analyst",
      "Data Scientist",
      "Data Engineer",
      "Customer Insights Analyst",
      "Growth Analyst",
      "HR, Sales, Accounting, & Finance Analyst",
      "And many, many more",
    ],
  },
];
